'use client';

import './styles/@theme';
import { SORT_OPTIONS, SortingType } from '../../constants';
import dynamic from 'next/dynamic';
import { classes } from '@/utils/classes/classes';
import { SvgLoader } from '@/app/elements/svg/loader';
import { useCategoryFilterContext } from '@/app/(pages)/(category)/c/[slug]/components/category-filter/context/category-filter-context';
import { useRef, useState } from 'react';

const FiltersPopup = dynamic(
    () =>
        import(
            '@/app/(pages)/(category)/c/[slug]/components/category-filter/subcomponents/filters-popup/filters-popup'
        ).then((mod) => mod.FiltersPopup),
    {
        ssr: false
    }
);

type CategoryFilterProps = {
    sortingType: SortingType | null;
    onSortClick: (sortKey: SortingType | null) => void;
};

export const CategoryFilter: React.FC<CategoryFilterProps> = ({ sortingType, onSortClick }) => {
    const { appliedFiltersCount, showPopUp, openPopUp, canFilter } = useCategoryFilterContext();
    const [filterPopupMounted, setFilterPopupMounted] = useState(false);
    const filterBtnRef = useRef<HTMLDivElement>(null);

    const onSortKeyClick = (key: SortingType) => {
        const keyToSortBy = key === sortingType ? null : key;
        onSortClick(keyToSortBy);
    };

    const renderSortingOptions = () =>
        SORT_OPTIONS.map((option) => {
            const className = classes(
                'switch-option',
                'sort',
                option.sortKey,
                sortingType === option.sortKey && 'active'
            );

            return (
                <button key={option.text} className={className} onClick={() => onSortKeyClick(option.sortKey)}>
                    {option.text}
                </button>
            );
        });

    const filtersMounted = (isMounted: boolean) => {
        setFilterPopupMounted(isMounted);
    };

    return (
        <div className="filters-buttons-container">
            <div className="switch-container">
                <p className="sort-by-label">Sort by:</p>
                {renderSortingOptions()}
                {canFilter && (
                    <div className="filters-btn-wrapper" ref={filterBtnRef}>
                        <button
                            className={classes('switch-option', 'filters', filterPopupMounted && 'selected')}
                            onClick={() => openPopUp(filterBtnRef.current)}>
                            {!!appliedFiltersCount && (
                                <span className="applied-filters-counter">{appliedFiltersCount}</span>
                            )}
                            Filters
                            <SvgLoader iconName="filter" />
                        </button>
                        {showPopUp && <FiltersPopup onMountStateChanged={filtersMounted} />}
                    </div>
                )}
            </div>
        </div>
    );
};
